import type { FaireProductEntity } from "../../entity_types/product";

export const p_73swt7xrer: FaireProductEntity = {
  token: "p_73swt7xrer",
  type: "product",
  name: "SLEEP SUPPORT COMPLEX w/ Magnesium Melatonin GABA L-Theanine",
  brandToken: "b_4oyyvczvtt",
  brandName: "DAILY DEFENSE",
  imageUrl:
    "https://cdn.faire.com/fastly/457fef2ff751d59cdd5bbf1ce694f4273c0fbbd810e9875574f950551fadf3fd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cbab55b70de09b8386b26178c8e7f1842c201955301e4ccc19f3168835711b26.jpeg",
    "https://cdn.faire.com/fastly/b5c3d067d343fbce0d3e0f4676d1f4d937db63e7e003086991188cd42794a515.jpeg",
    "https://cdn.faire.com/fastly/0997780ecbc819634c4f0c9a940a283534f82773af3c81f78ceec91c55cc9dab.jpeg",
    "https://cdn.faire.com/fastly/0e82ca3bd05c628e38c5b216d02fe6c1f27c073dbe20d4af481678c4b1c814b2.jpeg",
    "https://cdn.faire.com/fastly/52bae7bd386385688d4b010ffaa8240d09798d2086c73c961fb1d6117a1a357e.jpeg",
    "https://cdn.faire.com/fastly/16de5b5a8d4ba5b4764a9e0c438d10129be159bf146bde6ff5cafe6c8c7e96f7.jpeg",
    "https://cdn.faire.com/fastly/a6436cd88cfd493b4363ce69173cc9c730a90b22b3d1527d5a309cff95e13b27.jpeg",
    "https://cdn.faire.com/fastly/79850d1b0df2a5930478d485de2aad76f583b89cd7825d0920075c4597205407.jpeg",
    "https://cdn.faire.com/fastly/3378df49f8daeea68738db46b5003ace493e5d0848e42326e9acdcc88e01f75f.jpeg",
    "https://cdn.faire.com/fastly/88ce208762e343ff41489b9f83bd61e74bb84fcc3a18e4552c25424994ebd630.jpeg",
    "https://cdn.faire.com/fastly/2d47c32d483180fc3b991fa4c403e96fc8af56a262e855b1af66e5e2490b8df4.jpeg",
    "https://cdn.faire.com/fastly/cb72a45a2496ceb4adf11195a217227e4f333934e052dccf01f08efdb2fc75e0.jpeg",
    "https://cdn.faire.com/fastly/4458053a4f49ecec7c4cbaea547415a79af92cc6094d3afe4c9547de86f100fe.jpeg",
    "https://cdn.faire.com/fastly/ba53359e624cbf5cc5701751469a8011f48d8141a66b5b7e69aa7490e32c7111.jpeg",
  ],
  priceDollars: 14.97,
  description:
    "DAILY DEFENSE® SLEEP SUPPORT - a powerful blend of carefully selected ingredients that work synergistically to promote relaxation, calmness, and a restful night's sleep. With a unique combination of Magnesium (as magnesium oxide/citrate), L-Theanine, GABA, Phellodendron Bark Powder, Mucuna Pruriens Seed Extract, 5-HTP, and Melatonin, DAILY DEFENSE® SLEEP SUPPORT supplement is your ultimate solution for achieving a peaceful and rejuvenating sleep.\n\nBy incorporating DAILY DEFENSE® SLEEP SUPPORT supplement into your nightly routine, you can experience the tranquility and rejuvenation that come with a restful night's sleep. Our carefully selected blend of ingredients works together to promote relaxation, reduce anxiety, and support healthy sleep patterns, helping you wake up feeling refreshed and revitalized.",
  tags: [],
  msrpDollars: 29.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:32.983Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
